if (!customElements.get('pdp-update-price')) {
  class PDPUpdatePrice extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.delegateElement = new Delegate(this);
      this.selectedVariant = null;
      this.variantData = null;
    }

    connectedCallback() {
      console.log('PDPUpdatePrice');
    //   window.addEventListener('variant-change', this.handleVariantChange);

    //   this.delegateElement.on(
    //     'change',
    //     '[data-action="select-variant"]',
    //     this.onVariantChange.bind(this),
    //   );
    //   this.onVariantChange();
    }

    disconnectedCallback() {
    //   window.removeEventListener('variant-change', this.handleVariantChange);
    }

    onVariantChange(e) {
      this.reloadSelectedVariant();
    }

    reloadSelectedVariant() {
      this.updateOptions();
      this.updateMasterId();
    }

    updateMasterId() {
      this.selectedVariant = this.getVariantData().find((variant) => {
        const normalizedVariantOptions = variant.options.map((opt) =>
          opt ? this.normalizeOption(opt) : '',
        );
        const normalizedSelectedOptions = this.options.map((opt) =>
          opt ? this.normalizeOption(opt) : '',
        );

        if (
          this.areArraysEqual(
            normalizedSelectedOptions,
            normalizedVariantOptions,
          )
        ) {
          return true;
        }
      });

      // if no variant is found, avoid errors downstream
      if (!this.selectedVariant) {
        console.warn('No matching variant found for options:', this.options);
        return;
      }
    }

    updateOptions() {
      // this is where they set options to get the value
      this.options = Array.from(
        this.querySelectorAll(
          '.pm__option-selector:not(.not-variant, [aria-hidden="true"]) .pm__option-input:checked',
        ),
        (select) => {
          console.log('select options: ', select);
          return select.value;
        },
      );

      const t = document.querySelectorAll(
        '.pm__option-selector:not(.not-variant, [aria-hidden="true"]) .pm__option-input:checked',
      );

      console.log('this.options updateOptions: ', this.options);
      console.log('this.t updateOptions: ', t);
    }

    updatePrices() {
      console.log('Updating prices for variant: ', selectedVariant);

      if (!this.priceContainer) return;

      if (selectedVariant.compare_at_price) {
        const comparePrice = Shopify.formatMoney(
          selectedVariant.compare_at_price,
          window.theme.moneyFormat,
        );
        this.comparePrice.textContent = comparePrice;
        this.comparePrice.setAttribute('aria-hidden', 'false');
        this.saleLabel.setAttribute('aria-hidden', 'false');
      } else {
        this.comparePrice.setAttribute('aria-hidden', 'true');
        this.saleLabel.setAttribute('aria-hidden', 'true');
      }

      const realPrice = Shopify.formatMoney(
        this.selectedVariant.price,
        window.theme.moneyFormat,
      );
      this.realPrice.textContent = realPrice;

      const lowestPrices = this.lowestPrice.dataset.lowestPrices;
      if (!lowestPrices || lowestPrices.trim() === '') return;

      const lowestPrice = JSON.parse(lowestPrices)[selectedVariant.id];
      if (lowestPrice) {
        this.lowestPrice.querySelector('span').textContent =
          Shopify.formatMoney(lowestPrice, window.theme.moneyFormat);
        this.lowestPrice.setAttribute('aria-hidden', 'false');
      } else {
        this.lowestPrice.setAttribute('aria-hidden', 'true');
      }
    }

    normalizeOption(value) {
      return value
        .toLowerCase()
        .replace(/\s+/g, ' ') // collapse multiple spaces
        .trim();
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('#js-product-variants').textContent);

      return this.variantData;
    }

    areArraysEqual(arrayOne, arrayTwo) {
      if (arrayOne.length !== arrayTwo.length) {
        return arrayOne.every((element) => arrayTwo.includes(element));
      }

      const sortedArrayOne = arrayOne.slice().sort();
      const sortedArrayTwo = arrayTwo.slice().sort();

      return sortedArrayOne.every(
        (value, index) => value === sortedArrayTwo[index],
      );
    }
  }

  customElements.define('pdp-update-price', PDPUpdatePrice);
}
